import React from 'react';
import { LayoutBaseDePagina } from '../shared/layouts';
import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import { useAppThemeContext } from '../shared/contexts';

export const PaginaNaoEncontrada: React.FC = () => {

    const navigate = useNavigate();

    const { themeName } = useAppThemeContext();

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                minHeight: '100vh',
            }}
        >
            <Typography variant="h2" style={{ color: themeName === "light" ? 'black' : 'white', textAlign: 'center' }}>
                <b> Página não disponível </b>
            </Typography>
            <Typography variant="subtitle1" mt={1} style={{ color: 'grey', textAlign: 'center' }}>
                Você acessou uma página que já não existe ou que mudou de endereço.
            </Typography>
            <Button variant="contained" sx={{ mt: 5 }} onClick={() => navigate('/home')}>Página Inicial</Button>
        </Box>
    );

}
